// npm
import React from 'react'

// components
import PageHeading from './PageHeading.jsx'
import Breadcrumbs from './Breadcrumbs.jsx'

export default function ContentLayout({ title, children }) {
  return (
    <>
      <Breadcrumbs />
      <PageHeading title={ title } />
      <div className="py-8 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          { children }
        </div>
      </div>
    </>
  )
}
